'use client'

import { useState } from 'react'
import { Box } from '@chakra-ui/react'
import { getValidTranslation, ProductCategory } from '@leid/api-products'
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'

import { trackClickCategoryOnHomepage } from 'app/components/shared/Analytics/segment'
import { getCategoryName, getCategoryURL } from 'components/nav/CategoriesMenu/utils/categories'
import { CategoryCard } from 'components/ui/Card/CategoryCard'

import { CategoriesWrapper } from './styles'

type Props = {
  categories: ProductCategory[]
}

const HeroCategoryBox = ({ categories }: Props): JSX.Element => {
  const pathname = usePathname()
  const router = useRouter()

  const [selectedCategory, setSelectedCategory] = useState<number | undefined>(undefined)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCategoryBoxClick = async (categoryId: number, url: string, e: any) => {
    e.preventDefault()
    const category = categories.find((s) => s.id === categoryId)
    setSelectedCategory(categoryId)
    await trackClickCategoryOnHomepage(
      getValidTranslation('', category?.nameTranslations ?? [])?.translation ?? '',
      pathname ?? '',
    )
    router.push(url)
  }

  return (
    <CategoriesWrapper>
      {categories.map((category) => (
        <Box key={category.id}>
          <Link
            href={getCategoryURL(category, categories)}
            onClick={(e) => handleCategoryBoxClick(category.id, getCategoryURL(category, categories), e)}
          >
            <CategoryCard
              isCategorySelected={selectedCategory === category.id}
              category={{
                id: category.id,
                name: getCategoryName(category),
                url: category.imageUrl,
              }}
            />
          </Link>
        </Box>
      ))}
    </CategoriesWrapper>
  )
}

export default HeroCategoryBox
